import 'reflect-metadata';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'vue-datetime/dist/vue-datetime.css'
import authentication, {init as authenticationInit} from '@/configuration/authentication';
import App from './App.vue'
import firebase from './configuration/firebase';
import Vue from 'vue'
import VueTypedi from 'vue-typedi';
import router from './router'
import { AlertService } from './services/AlertService';
import { PageName } from './configuration/pages';
import { NO_RIGHTS_ERROR } from '@/configuration/authentication';
import {DriveService} from "@/services/DriveService";
import {Drive} from "@/model/Drive";
import {startVersionCheck} from "@/services/VersionCheckService";
import NoVirtualKeyboard from '@/directives/NoVirtualKeyboard';

Vue.config.productionTip = false;
Vue.use(VueTypedi);
Vue.directive('no-virtual-keyboard', NoVirtualKeyboard);
Vue.prototype.window = window;
Vue.prototype.$messaging = firebase.messaging;

startVersionCheck();

const FIREBASE_PERMISSION_ERROR = 'Permission to send notifications not granted.';
const FIREBASE_TOKEN_ERROR = 'An error occurred while retrieving the Firebase token.';

authenticationInit()
    .then(() => registerUser())
    .then(() => {
        const vue = new Vue({
            router,
            render: (h) => h(App),
        });
        vue.$mount("#app");
    })
    .then(() => initFirebase())
    .catch(error => {
        console.error(error);
        if (error !== FIREBASE_PERMISSION_ERROR && error !== FIREBASE_TOKEN_ERROR) {
            authentication.logout();
        }
    });

function registerUser() {
    return authentication.loadUserRights()
        .then(() => saveStoreId())
        .catch((error) => {
            console.error('An error occurred while initializing the authentication.', error);
            if(error === NO_RIGHTS_ERROR) {
                router.push({ name: PageName.SMART_COLLAB_ERROR });
            }
        });
}

function saveStoreId(): Promise<void> {
    if (authentication.isCentralAdmin()) {
        return;
    }
    const userDetails = authentication.userDetails();
    const storeId: string =  authentication.userRights()?.overrideStoreId ? authentication.userRights()?.overrideStoreId  : userDetails.site.id;
    sessionStorage.setItem("storeId", storeId);
    sessionStorage.setItem("storeLabel", userDetails.site.label);
    return (new DriveService()).getDrivesByStoreId(userDetails.site.id)
        .then((drives: Drive[]) => {
            sessionStorage.setItem("storeDrives", JSON.stringify(drives));
        });
}

export const refreshFirebaseToken = initFirebase;

function initFirebase(): Promise<string> {
    return firebase.registerClient().then((currentToken) => {
        if (currentToken) {
            console.info('Registering firebase token');
            const alertService = new AlertService();
            alertService.saveDeviceRegistrationId(currentToken, sessionStorage.getItem('storeId'));

            return Promise.resolve(currentToken);
        }

        return Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                console.debug('Notification permission granted.');
                return initFirebase(); // Try the registration once again
            }

            console.warn('Unable to get permission to notify.');
            return Promise.reject(FIREBASE_PERMISSION_ERROR);
        });

      }).catch((err) => {
        console.error('An error occurred while retrieving the Firebase token.', err);
        return Promise.reject(FIREBASE_TOKEN_ERROR);
      });
}
